/*  eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

import Dialog from '@material-ui/core/Dialog';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { connect } from 'react-redux';
import { addAttribute } from '../../../../Actions/Form';
import ContractsOverview from './ContractsOverview';

const Contracts = (props) => {
    const saveEwill = (data) => {
        let input = {};
        Object.keys(data).map((item) => {
            input[item] = {
                value: data[item],
            };
        });
        let json = {
          url: input.ID.value ? `important/${input.ID.value}` : 'important',
            method: input.ID.value ? 'PUT' : 'POST',
            system: {
                id: input.ID.value,
            },
            general: {
                importantType: 'contract',
                name: input.name ? input.name.value : '',
                contactID: input.contactID ? input.contactID.value + ';' : '',
            },
            meta: {
                additionalInfo: input.additionalInfo ? input.additionalInfo.value : '',
                tags: 'tag1;tag2',
            },
            contract: {
                contractType: input.contractType ? input.contractType.value : '',
                contractNumber: input.contractNumber ? input.contractNumber.value : '',
                customerNumber: input.customerNumber ? input.customerNumber.value : '',
            },
        };
        props.handleRequest('update', json);
        setaddNew(false);
    };

    const [addNew, setaddNew] = React.useState(false);
    const [newRecord, setnewRecord] = React.useState({
        contractType: '',
        contractNumber: '',
        customerNumber: '',
        additionalInfo: '',
        name: '',
        ID: '',
    });

    React.useEffect(() => {
        if (props.form.accountData && props.form.accountData.importantList) {
            let data = props.form.accountData.importantList.filter((item) => {
                return item.contract;
            });
            let contract = [];
            data.map((item) => {
                contract.push({
                    contractType: item.contract.contractType,
                    contractNumber: item.contract.contractNumber,
                    customerNumber: item.contract.customerNumber,
                    additionalInfo: item.meta.additionalInfo,
                    ID: item.system.id,
                    name: item.general.name,
                });
            });
            contract.sort(function (x, y) {
                let a = x.contractType,
                    b = y.contractType;
                return a == b ? 0 : a > b ? 1 : -1;
            });
            setpersonalData(contract);
        } else {
            setpersonalData([]);
        }
    }, [props.form.accountData && props.form.accountData.importantList]);

    const changeHandler = (event, personal) => {
        let data = personalData;
        let newData = newRecord;
        newData[event.target.name] = event.target.value;
        setnewRecord(newData);
        setpersonalData(JSON.parse(JSON.stringify(newData)));
    };
    const showAddContract = (finance) => {
        setaddNew(true);
        if (finance) {
            let newData = {};
            Object.keys(finance).map((item) => {
                newData[item] = finance[item];
            });
            setnewRecord(newData);
            props.addAttribute({
                name: 'selectedContract',
                value: finance,
            });
        } else {
            setnewRecord({
                contractType: '',
                contractNumber: '',
                customerNumber: '',
                additionalInfo: '',
                name: '',
                ID: '',
            });
            props.addAttribute({
                name: 'selectedContract',
                value: {},
            });
        }
    };
    const hideEdit = () => {
        setaddNew(false);
    };
    const [personalData, setpersonalData] = React.useState([]);

    return (
      <React.Fragment key={props.key}>
            {addNew === true && (
                <Dialog
                    open={addNew}
                    fullScreen={props.fullScreen}
                    disableEscapeKeyDown={true}
                    onClose={hideEdit}
                    aria-labelledby='responsive-dialog-title'
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'relative',
                        }}
                    >
                        <div
                            className='mm-form-container'
                        >
                            <div className='mm-login-container' style={{ boxShadow: 'none' }}>
                                <div className='mm-login-header'>
                                    {props.form.selectedContract && props.form.selectedContract.ID
                                        ? props.form.language.CONTRACT_EDIT
                                        : props.form.language.CONTRACT_ADD}
                                </div>
                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        Type
                                    </div>
                                    <div className='login-field-input'>
                                        <select
                                            className='mm-field-input '
                                            autoComplete="off"
                                            placeholder={props.form.language.HOUSE_TYPE}
                                            name={'contractType'}
                                            value={newRecord.contractType}
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        >
                                            <option value=''>
                                                {props.form.language.SELECT_OPTION}
                                            </option>
                                            <option value='property'>
                                                {props.form.language.SELECT_OPTION_PROPERTY}
                                            </option>
                                            <option value='financial'>
                                                {props.form.language.MYCONTACT_S7}
                                            </option>
                                            <option value='legal'>
                                                {props.form.language.SELECT_OPTION_LEGAL}
                                            </option>
                                            <option value='services'>
                                                {props.form.language.SELECT_OPTION_SERVICE}{' '}
                                            </option>
                                            <option value='other'>
                                                {props.form.language.TYPE_OTHER}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.NAME}
                                    </div>
                                    <div className='login-field-input'>
                                        <input
                                            type='text'
                                            autoComplete="off"
                                            placeholder={props.form.language.NAME}
                                            name='name'
                                            value={newRecord.name}
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.CONTRACT_CUSTOMER_NUM}
                                    </div>
                                    <div className='login-field-input'>
                                        <input
                                            type='text'
                                            autoComplete="off"
                                            placeholder={props.form.language.IS_APPLICABLE}
                                            name='customerNumber'
                                            value={newRecord.customerNumber}
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.CONTRACT_NUMBER}
                                    </div>
                                    <div className='login-field-input'>
                                        <input
                                            type='text'
                                            autoComplete="off"
                                            placeholder={props.form.language.IS_APPLICABLE}
                                            name='contractNumber'
                                            value={newRecord.contractNumber}
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.EXTRA_INFO}
                                    </div>
                                    <div className='login-field-input'>
                                        <textarea
                                            style={{ height: 'auto' }}
                                            rows='5'
                                            type='text'
                                            autoComplete="off"
                                            placeholder={props.form.language.EXTRA_INFO}
                                            name='additionalInfo'
                                            value={newRecord.additionalInfo}
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        />
                                    </div>
                                </div>

                                <div
                                    className='mm-input-submit'
                                    style={{
                                        display: 'flex',
                                        marginBottom: '15px',
                                        justifyContent: 'center',
                                    }}
                                >
                                    
                                    <button
                                        style={{
                                            textAlign: 'center',
                                            width: '150px',
                                            marginTop: '24px',
                                            marginRight: '20px',
                                        }}
                                        className='primary-button-blue'
                                        onClick={() => {
                                            saveEwill(newRecord);
                                            hideEdit();
                                        }}
                                    >
                                        {props.form.language.SAVE}
                                    </button>
                                    <button
                                        style={{
                                            textAlign: 'center',
                                            marginTop: '24px',
                                            
                                        }}
                                        className='secondary-button'
                                        onClick={hideEdit}
                                    >
                                        {props.form.language.CANCEL}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}
            {personalData &&
                personalData.length > 0 &&
                personalData.map((data) => {
                    return (
                        <ContractsOverview
                        key={`contract${data.ID}`}
                            data={data}
                            showAddContract={() => showAddContract(data)}
                            handleRequest={(type, data) => props.handleRequest(type, data)}
                        />
                    );
                })}
            <span
                id={props.type}
                onClick={(event) => {
                    showAddContract();
                }}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '8px',
                }}
            >
                <span className=''>
                    <span className='ewill-secondary-alert-sm'>
                        <AddIcon />
                    </span>
                </span>
                <span className='momentio-text-normal' style={{ marginLeft: '15px' }}>
                    {personalData.length > 0
                        ? props.form.language.CONTRACT_ADD_MULTIPLE
                        : props.form.language.CONTRACT_ADD}
                </span>
            </span>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return { ...state };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addAttribute: (payload) => dispatch(addAttribute(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Contracts);
